import { Box, Grid } from '@cmg/design-system';
import { FormikSelectField, FormikTextField } from '@cmg/design-system-formik';
import React from 'react';
import * as yup from 'yup';

import { offeringNoteFormSubjectOptions } from './constants';

type OfferingNoteFormProps = {
  loading?: boolean;
};

const OfferingNoteForm: React.FC<OfferingNoteFormProps> = ({ loading }) => {
  return (
    <Box>
      <Grid container spacing={2} pl={1}>
        <Grid item xs={4}>
          <FormikSelectField
            aria-label="Select note type"
            name="subject"
            label="Topic"
            required
            options={offeringNoteFormSubjectOptions}
            showHelperTextInTooltip
            disabled={loading}
            fullWidth
          />
        </Grid>
      </Grid>
      <FormikTextField
        label="Note"
        sx={{ mt: 2, ml: 1, pr: 2 }}
        aria-label="Enter note text"
        name="note"
        multiline
        required
        showHelperTextInTooltip
        rows={6}
        disabled={loading}
      />
    </Box>
  );
};

export const SubmitOfferingNotesSchema = yup.object().shape({
  subject: yup.string().label('Topic').nullable().required(),
  note: yup.string().label('Note').required(),
});

export default OfferingNoteForm;
